import { EToasterStatus, showToast } from 'utils/showToast';

export const handleExportCsv = (allowedPlayers: string[]) => {
  let csvContent = '';
  let filename = 'allowed_players.csv';

  if (!allowedPlayers || allowedPlayers.length === 0) {
    csvContent =
      '\uFEFFPlayerID\r\nplayer-id-1\r\nplayer-id-2\r\nplayer-id-3\r\nplayer-id-4\r\nplayer-id-5';
    filename = 'allowed_players_template.csv';
    showToast({
      message: 'Exporting template CSV.',
      status: EToasterStatus.SUCCESS
    });
  } else {
    const header = ['PlayerID'];
    const data = allowedPlayers.map((id) => [id]);
    csvContent = [header.join(','), ...data.map((row) => row.join(','))].join(
      '\n'
    );
  }

  const blob = new Blob([csvContent], { type: 'text/csv;charset=utf-8;' });

  const link = document.createElement('a');
  const url = URL.createObjectURL(blob);
  link.setAttribute('href', url);
  link.setAttribute('download', filename);
  link.style.visibility = 'hidden';
  document.body.appendChild(link);
  link.click();
};
